import { MessageCircle } from "lucide-react";
import { trackWhatsappClick } from "@/lib/tracking";

export default function FloatingWhatsapp({ number }) {
  const url = `https://wa.me/${number}`;
  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      onClick={() => trackWhatsappClick("floating")}
      className="mfp-wa-btn fixed bottom-5 right-5 md:bottom-8 md:right-8 z-30 h-14 w-14 md:h-16 md:w-16 text-white flex items-center justify-center mfp-pulse rounded-2xl hover:scale-105"
      aria-label="WhatsApp Chat öffnen"
      data-testid="floating-whatsapp"
    >
      <MessageCircle className="h-6 w-6 md:h-7 md:w-7" />
    </a>
  );
}
